import DescriptionFormType from "./Description.form";
import defaultUndefinedEnum from "../../../../functions/defaultUndefinedEnum.function";
import parseInteger from "../../../../functions/parseInteger.function";
import undefineBlankString from "../../../../functions/undefineBlankString.function";
import parseDecimal from "../../../../functions/parseDecimal.function";
import * as Fields from "../forms/fieldNames";
import TestRequestPurpose from "../../../../api/models/test-request/TestRequestPurpose";
import CustomerResponse from "../../../../api/models/customer/Customer.response";
import toIsoDate from "../../../../functions/toIsoDate.function";

type CreateTestRequestRQ = Required<TestRequestRaw.Schemas.CreateTestRequestRQ>;
type TestRequestDescriptionRq = TestRequestRaw.Schemas.TestRequestDescriptionRq;
type OemResponse = TestRequestRaw.Schemas.OemResponse;
type OemRq = TestRequestRaw.Schemas.OemRq;

function mapOem(oem: OemResponse | null): OemRq | undefined {
  return (
    (oem && {
      id: oem.id,
      name: oem.name,
    }) ||
    undefined
  );
}

function mapDistributor(distributor: { name: string; country: string; id: string } | null) {
  return distributor && distributor.id
    ? {
        uuid: distributor.id,
        name: distributor.name,
        country: distributor.country,
      }
    : undefined;
}

function mapCustomer(customer: CustomerResponse | null) {
  return customer || undefined;
}

export function mapToUpdateRequest(
  testRequestTitle: string,
  formularData: DescriptionFormType,
): TestRequestDescriptionRq {
  return {
    [Fields.OPPORTUNITY_PRODUCTS]: formularData[Fields.OPPORTUNITY_PRODUCTS],
    [Fields.PRIORITY]: formularData[Fields.PRIORITY] || undefined,
    [Fields.APPLICATION_FIELD]: undefineBlankString(formularData[Fields.APPLICATION_FIELD]),
    [Fields.APPROVER]: formularData[Fields.APPROVER] || undefined,
    [Fields.BACKGROUND_INFORMATION]: undefineBlankString(formularData[Fields.BACKGROUND_INFORMATION]),
    [Fields.BUSINESS_TYPE]: defaultUndefinedEnum(formularData[Fields.BUSINESS_TYPE], undefined),
    [Fields.BUSINESS_UNIT]: undefineBlankString(formularData[Fields.BUSINESS_UNIT]),
    [Fields.CRM_NO]: parseInteger(formularData[Fields.CRM_NO]),
    [Fields.CSC_LAB]: defaultUndefinedEnum(formularData[Fields.CSC_LAB], "_UNDEFINED"),
    [Fields.SOLUTION]: undefineBlankString(formularData[Fields.SOLUTION]),
    [Fields.DEADLINE]: formularData[Fields.DEADLINE] || "",
    [Fields.DEBITOR_NO]: parseInteger(formularData[Fields.DEBITOR_NO]),
    [Fields.DIRECT_CUSTOMER]: mapCustomer(formularData[Fields.DIRECT_CUSTOMER]),
    [Fields.DIRECT_CUSTOMER_CGR]: undefineBlankString(formularData[Fields.DIRECT_CUSTOMER_CGR]),
    [Fields.DIRECT_CUSTOMER_LOCATION]: formularData[Fields.DIRECT_CUSTOMER_LOCATION] || undefined,
    [Fields.CUSTOMER_CLASSIFICATION]: undefineBlankString(formularData[Fields.CUSTOMER_CLASSIFICATION]),
    [Fields.CUSTOMER_PART]: formularData[Fields.CUSTOMER_PART],
    [Fields.FINISHING_DATE]: toIsoDate(formularData[Fields.FINISHING_DATE]),
    [Fields.TEST_EFFORT_IN_DAYS]: parseDecimal(formularData[Fields.TEST_EFFORT_IN_DAYS]),
    [Fields.INTERNAL_CONTACTS]: formularData[Fields.INTERNAL_CONTACTS],
    [Fields.MARKET_SEGMENT]: undefineBlankString(formularData[Fields.MARKET_SEGMENT]),
    [Fields.PNS]: parseDecimal(formularData[Fields.PNS]),
    [Fields.CURRENCY]: defaultUndefinedEnum(formularData[Fields.CURRENCY], "_UNDEFINED"),
    [Fields.PRODUCT_REFERENCES]: formularData[Fields.PRODUCT_REFERENCES],
    [Fields.PROTOTYPE_PRODUCT_REFERENCES]: formularData[Fields.PROTOTYPE_PRODUCT_REFERENCES],
    [Fields.COMPETITOR_PRODUCT_REFERENCES]: formularData[Fields.COMPETITOR_PRODUCT_REFERENCES],
    [Fields.PROCESS_DETAIL]: formularData[Fields.PROCESS_DETAIL],
    [Fields.PROCESS_TYPE]: formularData[Fields.PROCESS_TYPE] || undefined,
    [Fields.CONFIDENTIALITY]: defaultUndefinedEnum(formularData[Fields.CONFIDENTIALITY], "_UNDEFINED"),
    [Fields.REPORT_LANGUAGE]: defaultUndefinedEnum(formularData[Fields.REPORT_LANGUAGE], "_UNDEFINED"),
    [Fields.REPORT_USAGE]: defaultUndefinedEnum(formularData[Fields.REPORT_USAGE], "_UNDEFINED"),
    [Fields.SPECIFICATION]: formularData[Fields.SPECIFICATION],
    [Fields.SUBSTRATES]: formularData[Fields.SUBSTRATES],
    [Fields.TEST_LOCATION]: defaultUndefinedEnum(formularData[Fields.TEST_LOCATION], undefined),
    [Fields.TEST_PROGRAM]: formularData[Fields.TEST_PROGRAM],
    [Fields.OEM]: mapOem(formularData[Fields.OEM]),
    [Fields.DISTRIBUTOR]: mapDistributor(formularData[Fields.DISTRIBUTOR]),
    [Fields.TITLE]: testRequestTitle,
    [Fields.TEST_PURPOSE]: defaultUndefinedEnum(formularData[Fields.TEST_PURPOSE], undefined),
    [Fields.EXTERNAL_DEVELOPMENT_BUDGET]: parseDecimal(formularData[Fields.EXTERNAL_DEVELOPMENT_BUDGET]),
    [Fields.EXTERNAL_DEVELOPMENT_BUDGET_CURRENCY_CODE]: defaultUndefinedEnum(
      formularData[Fields.EXTERNAL_DEVELOPMENT_BUDGET_CURRENCY_CODE],
      "_UNDEFINED",
    ),
  };
}

export default function mapToCreateRequest(
  testRequestTitle: string,
  formularData: DescriptionFormType,
  historical: boolean,
  purpose: TestRequestPurpose,
): CreateTestRequestRQ {
  return {
    description: mapToUpdateRequest(testRequestTitle, formularData),
    offset: "+00:00", // Explicitly send UTC offset
    historical,
    purpose,
  };
}
